import React, { Component } from 'react';
import { Facebook, Instagram, Youtube, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-white pt-20 pb-10 border-t-4 border-primary" data-id="element-33">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8" data-id="element-34">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-35">
          {/* Brand Column */}
          <div data-id="element-36">
            <div className="mb-8" data-id="element-37">
              <img src="https://cdn.magicpatterns.com/uploads/q4av7SXkTh841TBiCeZ1dj/PRO-Logo.png" alt="Pro One Design" className="h-24 w-auto object-contain" data-id="element-38" />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6 font-sans" data-id="element-39">
              Premium manufacturing of lift kits, leveling kits, and suspension
              components. Engineered for performance, built for durability.
            </p>
            <div className="flex gap-4" data-id="element-40">
              {[Facebook, Instagram, Youtube].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-primary hover:text-white transition-colors text-gray-400 border border-gray-700" data-id="element-41">
                  <Icon className="w-5 h-5" data-id="element-42" />
                </a>)}
            </div>
          </div>

          {/* Shop Links */}
          <div data-id="element-43">
            <h3 className="text-xl font-heading font-bold uppercase italic tracking-wider mb-6 text-white border-l-4 border-primary pl-3" data-id="element-44">
              Shop
            </h3>
            <ul className="space-y-3 text-gray-400 text-sm font-sans" data-id="element-45">
              {['Lift Kits', 'Leveling Kits', 'Shocks & Struts', 'Control Arms', 'Steering Components', 'Accessories'].map(item => <li key={item} data-id="element-46">
                  <a href="#" className="hover:text-primary transition-colors flex items-center gap-2 group" data-id="element-47">
                    <span className="w-1 h-1 bg-primary rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-48" />
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Support Links */}
          <div data-id="element-49">
            <h3 className="text-xl font-heading font-bold uppercase italic tracking-wider mb-6 text-white border-l-4 border-primary pl-3" data-id="element-50">
              Support
            </h3>
            <ul className="space-y-3 text-gray-400 text-sm font-sans" data-id="element-51">
              {['Installation Guides', 'Warranty Information', 'Return Policy', 'Shipping Policy', 'Dealer Locator', 'Contact Us'].map(item => <li key={item} data-id="element-52">
                  <a href="#" className="hover:text-primary transition-colors flex items-center gap-2 group" data-id="element-53">
                    <span className="w-1 h-1 bg-primary rounded-full opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-54" />
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-55">
            <h3 className="text-xl font-heading font-bold uppercase italic tracking-wider mb-6 text-white border-l-4 border-primary pl-3" data-id="element-56">
              Contact Us
            </h3>
            <ul className="space-y-4 text-gray-400 text-sm font-sans" data-id="element-57">
              <li className="flex items-start gap-3" data-id="element-58">
                <MapPin className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" data-id="element-59" />
                <span data-id="element-60">
                  123 Offroad Way
                  <br data-id="element-61" />
                  Fresno, CA 93727
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-62">
                <Phone className="w-5 h-5 text-primary flex-shrink-0" data-id="element-63" />
                <a href="tel:5591234567" className="hover:text-white transition-colors" data-id="element-64">
                  (559) 123-4567
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-65">
                <Mail className="w-5 h-5 text-primary flex-shrink-0" data-id="element-66" />
                <a href="mailto:sales@proonedesign.com" className="hover:text-white transition-colors" data-id="element-67">
                  sales@proonedesign.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500 font-sans" data-id="element-68">
          <p data-id="element-69">
            &copy; {new Date().getFullYear()} Pro One Design. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-70">
            <a href="#" className="hover:text-white transition-colors" data-id="element-71">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-72">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-73">
              Sitemap
            </a>
          </div>
        </div>
      </div>
    </footer>;
}